import React, { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

const Admin: React.FC = () => {
  const [adminSecret, setAdminSecret] = useState<string | null>(null);

  const handleLogin = (secret: string) => {
    setAdminSecret(secret);
  };

  const handleLogout = () => {
    setAdminSecret(null);
  };

  return (
    <>
      {adminSecret ? (
        <AdminDashboard adminSecret={adminSecret} onLogout={handleLogout} />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
    </>
  );
};

export default Admin;